// @ts-nocheck
// Re-render the cart drawer after gift lines were added or removed in the background.
// Debounced so a burst of cart:updated events results in one section fetch.
window.klyrRefreshCartDrawer = (() => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
      if (!sectionId) return;
      const url = new URL(window.Shopify.routes.root, window.location.origin);
      url.searchParams.set('sections', sectionId);
      if (window.Shopify.theme && window.Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      try {
        const sections = await fetch(url, { cache: 'no-store' }).then(res => res.json());
        if (!sections[sectionId]) return;
        // Background refresh: never let it pop the drawer (or cover the upsell sidebar).
        const drawer = document.querySelector('cart-drawer-component');
        const hadAutoOpen = drawer?.hasAttribute('auto-open');
        if (hadAutoOpen) drawer.removeAttribute('auto-open');
        const event = new Event('cart:update', { bubbles: true });
        event.detail = { resource: {}, sourceId: 'klyr-cart-refresh', data: { sections } };
        document.dispatchEvent(event);
        if (hadAutoOpen) drawer.setAttribute('auto-open', '');
      } catch (error) {
        console.error('Cart drawer refresh failed', error);
      }
    }, 400);
  };
})();

class FreeProductManager {
  constructor(drawerSelector) {
    this.drawer = document.querySelector(drawerSelector);

    // Free product info from data attributes
    this.freeVariantId = parseInt(this.drawer?.dataset.freeVariantId, 10);
    // Keep threshold in cents (don't convert)
    this.freeThreshold = parseInt(this.drawer?.dataset.freeProductThreshold, 10) || 0;
    this.busy = false;
    this.pending = false;

    document.addEventListener('cart:updated', (e) => {
      const cart = e.detail;
      this.handleFreeProduct(cart);
      window.klyrRefreshCartDrawer();
    });
  }

  async handleFreeProduct(cart) {
    // Several cart:updated events can arrive at once; run one sync at a time
    // so the free product is never added twice.
    if (this.busy) {
      this.pending = true;
      return;
    }
    this.busy = true;

    try {
      if (this.pending) {
        this.pending = false;
        cart = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' }).then(res => res.json());
      }

      // Mystery gift: free with 2+ Skin Corrector Pro bottles (not based on cart value).
      const GIFT_PRODUCT_IDS = [15295053496644, 15689888727364];
      const GIFT_MIN_BOTTLES = 2;
      const bottles = cart.items
        .filter(item => GIFT_PRODUCT_IDS.includes(item.product_id))
        .reduce((sum, item) => sum + item.quantity, 0);
      const jars = cart.items
        .filter(item => item.product_id === 15621417795908)
        .reduce((sum, item) => sum + item.quantity, 0);
      const eligible = bottles >= GIFT_MIN_BOTTLES || jars >= 4;
      const freeItem = cart.items.find(item => item.id === this.freeVariantId);
      let request = null;

      if (eligible && !freeItem) {
        // add free product
        request = fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.freeVariantId, quantity: 1 })
        });
      } else if (freeItem && (!eligible || freeItem.quantity !== 1)) {
        // remove free product (or reset it to one) by line key
        request = fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeItem.key, quantity: eligible ? 1 : 0 })
        });
      }

      if (request) {
        await request;

        // dispatch signal again
        const res = await fetch(`${window.Shopify.routes.root}cart.js`, { cache: 'no-store' });
        const newCart = await res.json();
        this.busy = false;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: newCart }));
        return;
      }
    } catch (error) {
      console.error('Free product sync failed', error);
    } finally {
      this.busy = false;
    }

    if (this.pending) this.handleFreeProduct(null);
  }
}

// ✅ Initialize
const freeProductManager = new FreeProductManager('.cart-drawer__inner');
